import React, { memo } from 'react'
import Typography from 'transfix-ui/core/Typography'
import { ICarrier } from 'types/carrier'
import { ConnectedPhoneNumber } from 'apps/marketplace/components/ConnectedPhoneNumber'
import { capitalize } from 'utils/capitalize'
import { DISPLAY } from 'constants/display'
import { LabelValue } from './LabelValue'

export const CompanyInformation = memo<{ carrier: ICarrier }>(
  ({
    carrier: {
      mcNumber,
      dotNumber,
      location: { city, contactPhone, contactPhoneExt, stateCode } = {},
      contactEmail,
    },
  }) => (
    <div data-test='company-details'>
      <div className='pv2'>
        <Typography variant='h3'>Company Information</Typography>
      </div>
      <LabelValue label='MC' clickToCopy>
        {mcNumber || DISPLAY.na}
      </LabelValue>
      <LabelValue label='DOT' clickToCopy>
        {dotNumber || DISPLAY.na}
      </LabelValue>
      <LabelValue label='HQ'>
        {city && stateCode ? `${capitalize(city)}, ${stateCode}` : DISPLAY.na}
      </LabelValue>
      <LabelValue label='Phone'>
        {contactPhone ? (
          <ConnectedPhoneNumber phoneNumber={contactPhone} phoneExtension={contactPhoneExt} />
        ) : (
          DISPLAY.na
        )}
      </LabelValue>
      <LabelValue label='Email'>
        {contactEmail ? (
          <a className='break-word' href={`mailto:${contactEmail}`}>
            {contactEmail.toLowerCase()}
          </a>
        ) : (
          DISPLAY.na
        )}
      </LabelValue>
    </div>
  )
)
